import React, { useEffect, useMemo, useState } from "react";
import "./TaskList.css";
import { useSelector } from "react-redux";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import TableHeader from "../Table/TableHeader";
import { useSession } from "../../authentications/SessionContext";
import TableBody from "../Table/TableBody";
import { CRM_TASK_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import Pagination from "../Table/TableFooter/Pagination";
import ActionButton from "../Buttons/ActionButton";
import { FaSearch } from "react-icons/fa";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { unLink } from "../../DataApi/unlink";
import TableLoader from "../Loaders/TableLoader";
import { handleResponse } from "../../utilities/handleResponse";
import TableToolbar from "../Table/TableToolbar";

const TaskList = ({
  refetchData,
  setIsModalOpen,
  setSelectedLead,
  setDefaultEdit,
}) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const { toggleModal, ConfirmationModal, setMetaData, setTitle } =
    useConfirmationModal();
  const { boards: ListViewData, loading } = useSelector((state) => state.crm);
  const { language, translations } = useLanguage();
  const t = translations[language];

  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [searchWithType, setSearchWithType] = useState("");
  const toggleSelectAll = () => {
    if (selectedRows.length === currentItems.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(currentItems?.map((task) => task.id));
    }
  };

  const handleEditList = (record) => {
    setIsModalOpen(true);
    setSelectedLead({ id: record });
    setDefaultEdit(true);
  };

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const indexOfLastItem = currentPage * PAGINATION_DEFAULT_LIMIT;
  const indexOfFirstItem = indexOfLastItem - PAGINATION_DEFAULT_LIMIT;
  const currentItems = ListViewData?.records || [];
  const length = ListViewData?.length || [];

  const handleChangePage = (value) => {
    setCurrentPage(value);
    refetchData("", (value - 1) * PAGINATION_DEFAULT_LIMIT, searchQuery);
  };

  const deleteLeads = async () => {
    let response = await unLink({
      id: selectedRows,
      company_id,
      context,
      model: "crm.lead",
    });
    response = JSON.parse(response);
    if (response?.result) {
      setSelectedRows([]);
      refetchData(null, currentPage - 1, searchQuery);
      toggleModal();
    }
    handleResponse({
      response,
      setTitle,
      setMetaData,
      successMessage: "Lead Deleted Successfully",
    });
  };
  const handleDeleteLead = () => {
    toggleModal();
  };

  useEffect(() => {
    if (typeof searchQuery !== "undefined") {
      refetchData(null, currentPage - 1, searchQuery);
    }
  }, [searchQuery]);

  const updatedCRMTableListView = useMemo(() => {
    const updatedList = [...CRM_TASK_LIST_TABLE_VIEW];
    updatedList.splice(0, 1, {
      ...updatedList[0],
      handleCell: (data, item) => {
        return (
          <input
            type="checkbox"
            checked={
              data
                ? selectedRows.includes(data[item.name])
                : selectedRows.length === ListViewData?.length
            }
            onChange={() =>
              data ? toggleSelectRow(data[item.name]) : toggleSelectAll()
            }
          />
        );
      },
    });
    return updatedList;
  }, [selectedRows, ListViewData]);
  return (
    <div className="listContainer">
      <ConfirmationModal handleYes={deleteLeads} handleNo={toggleModal} />
      <div className="table_container">
        <TableToolbar
          handleDelete={handleDeleteLead}
          handleEditList={handleEditList}
          searchWithType={searchWithType}
          setSearchWithType={setSearchWithType}
          setSearchQuery={setSearchQuery}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
        <table className="table">
          <TableHeader tableHeaderList={updatedCRMTableListView} />
          <TableBody
            tableData={currentItems}
            tableBodyList={updatedCRMTableListView}
            isLoadingData={loading === "pending" || loading === "idle"}
            checkIsLoadingData
          />
        </table>
        <Pagination
          ListViewData={ListViewData}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          currentPage={currentPage}
          handleChangePage={handleChangePage}
          PAGINATION_DEFAULT_LIMIT={PAGINATION_DEFAULT_LIMIT}
          totalDataLength={length}
        />
      </div>
    </div>
  );
};

export default TaskList;
